import * as go from 'gojs';
import { getImageConeCrusherCS } from 'unitData/Crushers/ConeCrusherCS/getImageConeCrusherCS';
import { getImageBinding, getIOPort, makeNode } from '../../utils';

const CrusherCSTemplate = makeNode(
  getImageBinding('showCustomModel', getImageConeCrusherCS),
  [getIOPort(go.Spot.Bottom, 'output'), getIOPort(go.Spot.Top, 'input')],
);

export default CrusherCSTemplate;
